var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,4H11c-4.4,0-8,3.6-8,8c0,0.6,0.4,1,1,1h4.9c1.7,0,3.1-1.4,3.1-3.1C12,9.4,12.4,9,12.9,9h6.1C19.6,9,20,9.4,20,9.9 c0,1.7,1.4,3.1,3.1,3.1H28c0.6,0,1-0.4,1-1C29,7.6,25.4,4,21,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,14.4C21.6,14.2,21.3,14,21,14h-2v-1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1h-2v-1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1h-2 c-0.3,0-0.6,0.2-0.8,0.4l-2.1,2.9C6.1,20.2,5,23.5,5,27c0,0.6,0.4,1,1,1h2v1c0,0.6,0.4,1,1,1s1-0.4,1-1v-1h12v1c0,0.6,0.4,1,1,1 s1-0.4,1-1v-1h2c0.6,0,1-0.4,1-1c0-3.5-1.1-6.8-3.1-9.6L21.8,14.4z M16,25c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S18.2,25,16,25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.26e90540.svg";
export { ForwardRef as ReactComponent };